import { Button, Tooltip } from 'antd';
import React from 'react';
import { RedoOutlined } from '@ant-design/icons';
import { NEXA_QUERY_RETRY_CLICK } from '../utils';
import { useAtomValue } from 'jotai';
import { chatStreamLoadingAtom, useNexaStore } from '../NexaStore';

interface RetryButtonProps {
  query: string;
}

export const RetryButton: React.FC<RetryButtonProps> = ({ query }) => {
  const isLoading = useAtomValue(chatStreamLoadingAtom);
  const id = useNexaStore((state) => state.id);

  // Check if ID is a share ID (starts with sh_) - hide retry in shared view
  const isShareId = id?.startsWith('sh_');

  if (isShareId) {
    return null;
  }

  const handleRetry = () => {
    window.dispatchEvent(new CustomEvent(NEXA_QUERY_RETRY_CLICK, { detail: query }));
  };

  return (
    <Tooltip title="Retry">
      <Button
        type="text"
        size="small"
        icon={<RedoOutlined />}
        onClick={handleRetry}
        disabled={isLoading}
        title="Retry this query"
        style={{ marginLeft: '8px' }}
      />
    </Tooltip>
  );
};
